import React from "react";
import { AlertTriangle, CheckCircle, Clock, Info } from "lucide-react";

const StatusRow = ({ region, info }) => {
  const isPaused = info.status === "Paused";
  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-100 last:border-0">
      <div className="flex items-center gap-4">
        <div
          className={`p-2 rounded-full ${
            isPaused
              ? "bg-amber-100 text-amber-600"
              : "bg-green-100 text-green-600"
          }`}
        >
          {isPaused ? <AlertTriangle size={20} /> : <CheckCircle size={20} />}
        </div>
        <div>
          <h4 className="font-semibold text-slate-800">{region} Lead Flow</h4>
          <p className="text-sm text-slate-500">{info.reason}</p>
        </div>
      </div>
      <div className="text-right">
        <span
          className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
            isPaused
              ? "bg-amber-50 text-amber-700 border border-amber-200"
              : "bg-green-50 text-green-700 border border-green-200"
          }`}
        >
          {info.status.toUpperCase()}
        </span>
        <p className="text-xs text-slate-400 mt-1 flex items-center justify-end gap-1">
          <Clock size={12} /> Action: {info.nextAction}
        </p>
      </div>
    </div>
  );
};

const LeadFlowStatusCard = ({ data }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 h-full flex flex-col">
      <div className="p-5 border-b border-slate-100 flex justify-between items-center">
        <h3 className="font-bold text-lg text-slate-800">
          Integration & Delivery Status
        </h3>
        <span className="text-xs font-mono text-slate-400">LIVE MONITOR</span>
      </div>

      <div>
        <StatusRow region="India" info={data.India} />
        <StatusRow region="Asia" info={data.Asia} />
      </div>

      {/* STRATEGIC EXPLAINER ADDED HERE */}
      <div className="p-4 bg-blue-50 m-4 rounded-lg border border-blue-100 flex gap-3">
        <Info className="text-blue-600 flex-shrink-0" size={20} />
        <div className="text-sm text-blue-800">
          <p className="font-semibold mb-1">Strategic Optimization Window</p>
          <p className="opacity-90">
            While integration approval is in progress, nurture streams are being
            designed so leads can enter a fully built, needs-based journey on
            Day 1.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeadFlowStatusCard;
